// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voting-instructions__agenda__more-container{display:flex;justify-content:flex-end;align-items:center;color:#00716b}.voting-instructions__agenda__more-container *{margin:unset}.voting-instructions__agenda__more{display:flex;justify-content:flex-end;align-items:center;cursor:pointer}.voting-instructions__agenda__more:hover{text-decoration:underline}.voting-instructions__agenda__explanation-container{border-left:2px solid #37aba1 !important}", ""]);
// Exports
module.exports = exports;
